import MileageSettingsDetailsRequest from "../../../../api/raily/mileage/settings/details/mileage-settings-details.request";
import MileageSettingsDetailsParams from "./mileage-settings-details-params";

const create = (
  params: MileageSettingsDetailsParams,
): MileageSettingsDetailsRequest => {
  return {
    cargoCompanyUuid: params.cargoCompanyUuid,
    active: params.active,
  };
};

const mileageSettingsDetailsParamsFactory = {
  create,
};

export default mileageSettingsDetailsParamsFactory;
